import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _SearchStudents = async (serachData = false) => {
  let url = ServiceUrl.STUDENTS.SEARCH_STUDENT_BY_NO;
  return callApi(url, "post", serachData && serachData);
};

export const _MY_ELECTIVE_SELECTION_LIST = async (searchData = false) => {
  let url = ServiceUrl.STUDENTS.MY_ELECTIVE_SELECTION_LIST;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};

export const _ONLINE_TRANSPORT_LIST = async (searchData = false) => {
  let url = ServiceUrl.STUDENTS.ONLINE_TRANSPORT_LIST;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};

export const _SAVE_TRANSPORT_PREFERENCE = async (serachData = false) => {
  let url = ServiceUrl.STUDENTS.SAVE_TRANSPORT_PREFERENCE;
  return callApi(url, "post", serachData && serachData);
};
